import {
  OreButton,
  OreCardContainer,
  OreCardWrapper,
  OreDivider,
  OreStack,
  OreText,
} from '@edenredespana/oreneta'
import { FormProvider } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { formTranslation } from '@/Shared/ui/sharedTranslation'
import { createApiStoreRepository } from '@/Store/infrastructure'
import { useStoreController } from '@/Store/ui/hooks/useStoreController'
import { MyStoreAddressFormRestaurant } from '@/Store/ui/molecules'
import { MyStoreBasicFormRestaurant } from '@/Store/ui/molecules/MyStoreBasicFormRestaurant'
import { storesTranslation } from '@/Store/ui/storesTranslation'
import { useUserData } from '@/User/ui/context'
import { useWebTagPermissions } from '@/User/context/WebTagPermissionsProvider'
import { WebTagPermissionEnum } from '@/Shared/domain'

export const MyStoreFormRestaurant = (): JSX.Element => {
  const { t } = useTranslation()
  const { hasPermission } = useWebTagPermissions()
  const { merchant } = useUserData()
  const { form, foodTypes, save, } = useStoreController(
    createApiStoreRepository(),
    merchant,
  )

  const show = hasPermission(WebTagPermissionEnum.ACTION_LOCAL_DATA_CHANGE)
  return (
    <FormProvider {...form}>
      <form>
        <OreCardContainer>
          <OreCardWrapper>
            <OreStack space="2xlarge" placeContent="stretch">
              <MyStoreBasicFormRestaurant foodTypes={foodTypes} show={show} merchant={merchant}/>
              <MyStoreAddressFormRestaurant show={show} merchant={merchant}/>
              <OreText>{t(formTranslation.common.requiredFields)}</OreText>
            </OreStack>
          </OreCardWrapper>
        </OreCardContainer>

        <OreDivider space="larger-top" />
        <OreStack direction="row" placeContent="end" space="medium">
          <OreButton
            size="small"
            disabled={!form.formState.isDirty}
            onClick={() => {
              form.reset()
            }}
            category="secondary"
          >
            {t(storesTranslation.myStore.form.cancelLabel)}
          </OreButton>
          <OreButton
            disabled={!form.formState.isDirty}
            type="submit"
            onClick={form.handleSubmit(save)}
            size="small"
            category="primary"
          >
            {t(storesTranslation.myStore.form.editLabel)}
          </OreButton>
        </OreStack>
      </form>
    </FormProvider>
  )
}
